import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { paragraphLarge, paragraphRegular, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import CardTagsStyles from '../CardTags/CardTags.styles';
import TopicTagsStyles from '../TopicTags/TopicTags.styles';
const Container = styled.article `
  container-type: inline-size;

  ${TopicTagsStyles.Container} {
    margin-top: 4px;
  }
`;
const Inner = styled.a `
  position: relative;
  display: grid;
  gap: 12px ${fluid(16, 32)};
  padding: ${fluid(16, 32)};
  border-radius: 12px;
  color: ${brand.primary.blue};
  text-decoration: none;
  background-color: ${brand.global.white};
  border: 1px solid currentColor;

  /* Add a box shadow for the hover state */
  &::before {
    ${transition('opacity')};

    --shadow-color: 0deg 0% 77%;

    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    height: 100%;
    width: 100%;
    background-color: transparent;
    opacity: 0;
    pointer-events: none;
    /* Generated using https://www.joshwcomeau.com/shadow-palette/ */
    box-shadow: 0px 0.2px 0.2px hsl(var(--shadow-color) / 0.2),
      0px 0.6px 0.7px -0.4px hsl(var(--shadow-color) / 0.2),
      -0.1px 1.1px 1.2px -0.7px hsl(var(--shadow-color) / 0.2),
      -0.1px 1.7px 1.9px -1.1px hsl(var(--shadow-color) / 0.2),
      -0.2px 2.8px 3.2px -1.4px hsl(var(--shadow-color) / 0.2),
      -0.3px 4.3px 4.8px -1.8px hsl(var(--shadow-color) / 0.2),
      -0.4px 6.5px 7.3px -2.1px hsl(var(--shadow-color) / 0.2),
      -0.6px 9.5px 10.7px -2.5px hsl(var(--shadow-color) / 0.2);
  }

  &:focus-visible {
    outline-style: solid;
    outline-offset: 2px;
    outline-width: 1px;
    outline-color: currentColor;
  }

  &:focus-visible,
  &:hover {
    &::before {
      opacity: 1;
    }
  }

  @container ${from(Device.TabletSmall)} {
    &:has(${CardTagsStyles.Container}) {
      grid-template-columns: 1fr auto;
    }

    ${CardTagsStyles.Container} {
      grid-column: 2;
      margin-bottom: auto;
    }
  }
`;
const Name = styled.h3 `
  ${transition('text-decoration-color')};
  ${paragraphLarge};

  font-style: normal;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.2px;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
  grid-column: 1;
  margin: auto 0 0;

  ${Inner}:focus-visible &,
  ${Inner}:hover & {
    text-decoration-color: currentColor;
  }

  @container ${from(Device.TabletSmall)} {
    grid-row: 1;
  }
`;
const Description = styled.p `
  ${paragraphRegular};

  margin: 0;
  grid-column: 1 / -1;
`;
const Attributes = styled.ul `
  ${paragraphSmall};

  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  opacity: 0.5;
  margin: 0;
`;
const SearchResultCardStyles = {
    Attributes,
    Container,
    Description,
    Inner,
    Name,
};
export default SearchResultCardStyles;
